import { CountryType, isSweden } from 'src/app/core/entity/locale';
import {
  isValidCorporateIdentity as isValidSwedishCorporateIdentity,
  isValidKvkNumber as isValidDutchCorporateIdentity,
} from '@bl/functions';

export const getCorporateIdentityValidatorByCountry = (countryCode: CountryType) => {
  return isSweden(countryCode) ? isValidSwedishCorporateIdentity : isValidDutchCorporateIdentity;
};
